import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as dates from '@simplybenefits/sb-dates';
import { Button, Text, Theme, Modal, NumberInput, TextInput, Loader, Services } from '@simplybenefits/sb-ui-library';
import { 
    Add as AddIcon,
    Delete as TrashIcon 
} from '@mui/icons-material';
import { helpers } from '@simplybenefits/sb-utils';
import { getCarryForward, removeCarryForward, addCarryForward } from '../../actions/carryForward.js';
import PermissionsComponent from '../../components/PermissionsComponent.js';

class CarryForward extends PureComponent {
    state = {
        carryForwards: [],
        memberCarryForwardTypesMap: {
            'Group Benefits': 'standard',
            'Voluntary Marketplace': 'voluntary'
        },
        showRemovalModal: false,
        showAddModal: false,
        selectedCarryForward: null,
        amount: '',
        divisionName: '',
        memberCarryForwardType: '',
        amountError: false,
        divisionNameError: false,
        memberCarryForwardTypeError: false
    };

    async componentDidMount() {
        const carryForwards = await this.props.dispatch(getCarryForward(this.props.isDivision, this.props.isDivision ? this.props.accountID : this.props.userID));

        await this.setState({
            carryForwards: carryForwards || []
        });
    }

    async _removeCarryForward() {
        const success = await this.props.dispatch(removeCarryForward(this.props.isDivision, this.state.selectedCarryForward));

        if (success) {
            await this.setState({
                showRemovalModal: false
            });

            window.location.reload();
        }
    }

    async _validateForm() {
        let divisionNameError = false;
        let memberCarryForwardTypeError = false;
        const amountError = await Services.validateInput('checkEmpty', this.state.amount);

        if (this.props.isDivision) {
            divisionNameError = await Services.validateInput('checkEmpty', this.state.divisionName);
        }

        if (!this.props.isDivision) {
            const isTypeInMap = this.state.memberCarryForwardType in this.state.memberCarryForwardTypesMap;
            const isEmpty = await Services.validateInput('checkEmpty', this.state.memberCarryForwardType);

            memberCarryForwardTypeError = isEmpty || !isTypeInMap;
        }

        await this.setState({
            amountError,
            divisionNameError,
            memberCarryForwardTypeError
        });

        if (amountError || divisionNameError || memberCarryForwardTypeError) {
            return false;
        }

        return true;
    }

    async _addCarryForward() {
        let divisionID = null;

        const valid = await this._validateForm();

        if (!valid) {
            return;
        }

        if (this.props.isDivision) {
            divisionID = Object.keys(this.props.divisions).find((key) => this.props.divisions[key].title === this.state.divisionName);
        }

        const entityID = this.props.isDivision ? divisionID : this.props.userID;
        const type = !this.props.isDivision ? this.state.memberCarryForwardTypesMap[this.state.memberCarryForwardType] : null;
        const success = await this.props.dispatch(addCarryForward(this.props.isDivision, this.state.amount, entityID, type));

        if (success) {
            console.log("In Success", this.state.show);

            await this.setState({
                showAddModal: false
            });

            window.location.reload();
        }
    }

    render() {
        const { isDivision } = this.props;
        let totals = 0;
        let divisionTitles = null;
        const carryForwardTypes = Object.entries(this.state.memberCarryForwardTypesMap).reduce((acc, [ k, v ]) => {
            acc[v] = k;
            return acc;
        }, {});

        if (isDivision) {
            divisionTitles = helpers.sortObjByTitle(this.props.divisions).map((divisionID) => ({
                key: divisionID,
                value: this.props.divisions[divisionID].title
            }));
        }

        const styles = {
            titleBlock: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: 15
            },
            block: {
                backgroundColor: Theme.colors.surface,
                boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
                height: 'auto'
            },
            header: {
                display: 'flex',
                flexDirection: 'row',
                flex: 1,
                alignItems: 'center',
                padding: '10px 30px 10px 30px'
            },
            row: {
                display: 'flex',
                flexDirection: 'row',
                flex: 1,
                alignItems: 'center',
                padding: '10px 30px 10px 30px',
                borderTop: "1px solid #eee"
            },
            rowItem: {
                width: '18%'
            },
            trash: {
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "center",
                flex: 1
            }
        };

        return (
            <div>
                <div style={ styles.titleBlock }>
                    <Text large bold >
                        { isDivision ? 'Division Carry Forwards' : 'Member Carry Forwards'}
                    </Text>

                    <PermissionsComponent
                        permission="Invoices"
                        accessType={this.props.accessType}
                        level="write"
                    >
                        <Button
                            transparent
                            onClick={ () => this.setState({ showAddModal: true }) }
                            customStyle={{
                                marginLeft: 'auto',
                                textTransform: 'capitalize'
                            }}
                        >
                            <AddIcon style={{ fontSize: 17, lineHeight: '14px', color: 'inherit' }} />&nbsp;
                            Add Carry Forward
                        </Button>
                    </PermissionsComponent>
                </div>

                {
                    this.state.carryForwards.length === 0 ?
                        <Text large light>No Records</Text>
                        :
                        <div style={ styles.block}>
                            <div style={ styles.header } >
                                <div style={ styles.rowItem }>
                                    <Text medium bold>Carry Forward ID</Text>
                                </div>

                                {
                                    isDivision ?
                                        <div style={ styles.rowItem }>
                                            <Text medium bold>Division</Text>
                                        </div>
                                        :
                                        null
                                }

                                <div style={ styles.rowItem }>
                                    <Text medium bold>Date Created</Text>
                                </div>

                                {
                                    !isDivision ?
                                        <div style={ styles.rowItem }>
                                            <Text medium bold>Carry Forward Type</Text>
                                        </div>
                                        :
                                        null
                                }

                                <div style={styles.rowItem }>
                                    <Text medium bold customStyle={{ textAlign: 'center' }}>Entry Type</Text>
                                </div>

                                <div style={ styles.rowItem }>
                                    <Text medium bold customStyle={{ textAlign: 'center' }}>Carry Forward Amount</Text>
                                </div>
                            </div>

                            {
                                this.state.carryForwards.map((carryForward, index) => {
                                    totals += carryForward.amount;
                                    return (
                                        <div style={styles.row} key={index}>
                                            <div style={ styles.rowItem }>
                                                <Text medium light>{ carryForward.carryForwardID }</Text>
                                            </div>

                                            {
                                                isDivision ?
                                                    <div style={ styles.rowItem }>
                                                        <Text medium light>{ carryForward.title }</Text>
                                                    </div>
                                                    :
                                                    null
                                            }

                                            <div style={ styles.rowItem }>
                                                <Text medium light>{ dates.getLocalDisplay(carryForward.dateAdded, 'lll') }</Text>
                                            </div>

                                            {
                                                !isDivision ?
                                                    <div style={ styles.rowItem }>
                                                        <Text medium light>{ carryForwardTypes[carryForward.type] || carryForward.type }</Text>
                                                    </div>
                                                    :
                                                    null
                                            }

                                            <div style={ styles.rowItem }>
                                                <Text medium light customStyle={{ textAlign: 'center' }}>{ carryForward.amount > 0 ? 'Debit' : 'Credit' }</Text>
                                            </div>

                                            <div style={ styles.rowItem }>
                                                <Text medium light customStyle={{ textAlign: 'center' }}>${ helpers.formatNumber(carryForward.amount) }</Text>
                                            </div>

                                            <PermissionsComponent
                                                permission="Invoices"
                                                accessType={this.props.accessType}
                                                level="write"
                                            >
                                                <div style={styles.trash}>
                                                    <Button
                                                        onClick={() => this.setState({ showRemovalModal: true, selectedCarryForward: carryForward.carryForwardID })}
                                                        transparent
                                                    >
                                                        <TrashIcon style={{ fontSize: 17, lineHeight: '14px', color: 'inherit' }} />
                                                    </Button>
                                                </div>
                                            </PermissionsComponent>
                                        </div>
                                    );
                                })
                            }

                            <div style={styles.row}>
                                <div style={ styles.rowItem }>
                                    <Text medium bold>Total</Text>
                                </div>

                                {
                                    isDivision ?
                                        <div style={ styles.rowItem }>
                                            <Text medium bold>-</Text>
                                        </div>
                                        :
                                        null
                                }

                                <div style={ styles.rowItem }>
                                    <Text medium bold>-</Text>
                                </div>

                                {
                                    !isDivision ?
                                        <div style={ styles.rowItem }>
                                            <Text medium bold>-</Text>
                                        </div>
                                        :
                                        null
                                }

                                <div style={ styles.rowItem }>
                                    <Text medium bold customStyle={{ textAlign: 'center' }}>{ totals > 0 ? 'Debit' : 'Credit' }</Text>
                                </div>

                                <div style={ styles.rowItem }>
                                    <Text medium bold customStyle={{ textAlign: 'center' }}>${ helpers.formatNumber(totals) }</Text>
                                </div>
                            </div>
                        </div>
                }

                <Modal
                    open={ this.state.showRemovalModal }
                    onClose={ () => this.setState({ showRemovalModal: false })}
                    title="Remove Carry Forward"
                    primaryButton={{
                        label: 'Remove Carry Forward',
                        onClick: () => this._removeCarryForward()
                    }}
                    loader={this.props.loader}
                >
                    <Text medium>
                        Are you sure you want to remove this carry forward? All data for this record will be lost.
                    </Text>
                </Modal>

                <Modal
                    open={ this.state.showAddModal }
                    onClose={ () => this.setState({ showAddModal: false })}
                    title="Add Carry Forward"
                    primaryButton={{
                        label: 'Add Carry Forward',
                        onClick: () => this._addCarryForward()
                    }}
                    loader={this.props.loader}
                >
                    {
                        isDivision ?
                            <TextInput
                                label="Division"
                                variant="outlined"
                                value={this.state.divisionName || ''}
                                onChange={(e) => this.setState({ divisionName: e.target.value })}
                                select
                                required
                                fullWidth
                                selectOptions={ divisionTitles }
                                error={Boolean(this.state.divisionNameError)}
                            />
                            :
                            null
                    }

                    {
                        !isDivision ?
                            <TextInput
                                label="Carry Forward Type"
                                variant="outlined"
                                value={ this.state.memberCarryForwardType }
                                onChange={(e) => this.setState({ memberCarryForwardType: e.target.value })}
                                select
                                required
                                fullWidth
                                selectOptions={ Object.keys(this.state.memberCarryForwardTypesMap) }
                                error={ Boolean(this.state.memberCarryForwardTypeError) }
                            />
                            :
                            null
                    }

                    <NumberInput
                        label="Carry Forward Amount"
                        fullWidth
                        prefix="$"
                        value={ this.state.amount || '' }
                        variant="outlined"
                        required
                        allowNegative
                        onChange={(e) => this.setState({ amount: e.target.value })}
                        error={Boolean(this.state.amountError)}
                    />
                </Modal>

                {(this.props.accountLoading || this.props.userLoading) && <Loader />}
            </div>
        );
    }
}

CarryForward.propTypes = {
    accountLoading: PropTypes.bool,
    userLoading: PropTypes.bool
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    divisions: state.accounts.currentAccount.divisions,
    accountLoading: state.accounts.loading,
    userLoading: state.users.loading,
    accessType: state.master.access
});

export default connect(mapStateToProps)(CarryForward);